import { render } from "./AccountingMonthDatatableTDSalariesAction.vue?vue&type=template&id=0bfb604c"
import script from "./AccountingMonthDatatableTDSalariesAction.vue?vue&type=script&lang=js"
export * from "./AccountingMonthDatatableTDSalariesAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__